function formatCurrency(value, fraction = 2) {
  if (value == null || isNaN(value) || value === "") return "$0.00";
  value = value + "";
  let num = parseFloat(value.replace(/[$,]/g, "")); // Remove $ and commas, then parse to number
  let formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: fraction,
    maximumFractionDigits: fraction,
  }).format(num);
  return formatted.replace(/\s/g, ""); // Ensure dollar sign formatting remains consistent
}

module.exports = { formatCurrency };
